<ion-header style="background-color: #e69f00;"> 
    <ion-row class ="blueheader" >
            <ion-col translate paramdata="Hello">
            , {{currentWorker.FirstName}}! 
            <span *ngIf="currentWorker.stringWorkerId">({{currentWorker.stringWorkerId}}) </span> 
            </ion-col>
        </ion-row>
    <ion-row class = "grayheader">
        <div translate paramdata="ClientView"></div>
    </ion-row>
</ion-header>

<ion-content>

    <div class = "clientlist" *ngIf = "!noMatchedClients">
        <div class ="clientitem" *ngFor = "let client of currentWorker.assignedClients; let i = index"> 
            <div class="completion" translate paramdata="Completion" *ngIf = "client.visitStatus == 6 || client.visitStatus == 7"></div>
                <div>
                    <span class = "clientname"> {{i+1}}) {{client.firstName}} {{client.lastName}} </span>
                </div>
                <div>
                    <button translate paramdata="ReportArrival" ion-button class = "reportArrival" (click) = "nextStatus(client)" *ngIf ="client.visitStatus != 5 && !this.visitStarted">
                    </button>
                    <button translate paramdata="ReportDeparture" ion-button class = "reportDeparture" (click) = "nextStatus(client)" *ngIf ="client.visitStatus == 5">
                    </button>
                </div>
        </div>
    </div>
    <div class = "nomatched" *ngIf = "noMatchedClients" translate paramdata="NoMatchedClients">
         {{currentWorker.businessName}}!
    </div>
</ion-content>

<ion-footer>
<ion-row class= "footerrow">
    <ion-col>
        <button translate paramdata="Logout" ion-button class ="footerbutton" (click) = "logOut()"></button>
    </ion-col>
</ion-row>
</ion-footer>
